import React, { useState, useEffect } from "react"

import ContactDirectoryHeader from "@/app/pages/contactDirectory/ContactDirectoryHeader"
import TabsAndInputSearchBox from "@/components/SearchAndResultShared/TabsAndInputSearchBox";
import Breadcrumb from "@/components/breadCrumb";
import ContactDirectoryBlock from "@/app/pages/contactDirectory/ContactDirectoryBlock";
import { ContactDirectoryIndustryBrowseFragment } from "@/app/pages/businessDirectory/ContactDirectoryIndustryBrowseFragment";

import "@/app/pages/contactDirectory/styles/ContactDirectoryHeaderStyles.scss";
import { getIndustries } from "@/services/businessDirectory";
import Overlay from "@/components/overlay";
import { useTranslation } from "react-i18next";
import {setDigitalData} from "@/services/setDigitalData";
import { dnbComLog, LogSeverity } from "@/shared/FunctionCore";


const ContactDirectory = (businessDirectoryProps) => {
  const { t } = useTranslation();
  const [contactDirectoryIndustryData, setContactDirectoryIndustryData] = useState([])

  const breadcrumbs = [
    { name: t("contactDirectory.searchResultStartBreadcrumb"), url: t("homeRedirection"), useAnchorTag: true },
    { name: t("contactDirectory.searchResultCDBreadcrumb"), url: t("contactProfilesPage") }
  ];

  setDigitalData({gcpPageName: 'contactDirectory'});

  useEffect(() => {
    const getIndustryData = async () => {
      try {
        const data = await getIndustries();

        if (data) {
          const arr = data?.data?.industries;
          const resultData: any = Object.values(arr)
          const res: any = { industryTitleUrlRewritten: resultData }
          setContactDirectoryIndustryData(res)
        }
      }
      catch (error) {
        dnbComLog(LogSeverity.ERROR, error);
      }
    }
    getIndustryData();
  }, [])

  return (
    <>
      <ContactDirectoryHeader />
      <TabsAndInputSearchBox {...businessDirectoryProps} />
      <div className="bd-landing-content">
        <div className="directoryContainer px-3 mt-3">
          <Breadcrumb
            breadcrumbs={breadcrumbs}
            forComponent="contactDirectory"
            delimiter="/"
            styling="font-style-light"
          />
          <ContactDirectoryBlock />
        </div>
        <ContactDirectoryIndustryBrowseFragment
          headerTextLabel="Explore contacts in these Industries"
          contactDirectoryIndustryData={contactDirectoryIndustryData}
          additionalContainerClass="contactListWrapper"
        />
      </div>
      <Overlay countryCode={businessDirectoryProps.countryCode}
        isEmailDisplay={false}
        isPhoneDisplay={false}
        isRecaptchaDisplay={['us'].includes(businessDirectoryProps.countryCode)}
        recaptchaActionName={t("contactDirectory.recaptchActionName")}
      />
    </>
  )
}

export default ContactDirectory